<template>
  <el-popover
    placement="bottom"
    popper-class="df-popover"
    width="120"
    trigger="click"
  >
    <span class="nf-flex vertical">
      <a class="df-action" :href="userCenterURL" target="_self">
        <span>{{
          TLang("个人中心", "my")
        }}</span>
      </a>
      <a class="df-action" @click="onLogout">
        <span>{{
          TLang("退出账号", "my")
        }}</span>
      </a>
    </span>
    <span slot="reference">
      <df-nav-item slot="reference" class="nf-clickable">
        <i class="icon_people"></i>
        <span>{{ userAccount }}</span>
        <i class="df-arrow"></i>
      </df-nav-item>
    </span>
  </el-popover>
</template>

<script>
import {cookieKeys, removeCookie, unionFlag} from "../../../utils";
import cache from "@utils/cache";

export default {
  name: "User",
  props: {
    unionHead: {
      type: Object,
      default: () => null,
    },
    loginData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loginInfo: {},
    };
  },
  computed: {
    userAccount() {
      const { account } = this.loginData;
      return account;
    },
    userCenterURL() {
      const { userCentUrl } = this.unionHead;
      return userCentUrl;
    },
  },
  created() {
    this.getLoginStatus();
  },
  methods: {
    getLoginStatus() {
      // this.apis.headerApi.getLoginStatus().then((res) => {
      //   this.loginInfo = res;
      //   cache.session.set("loginInfo", res);
      // });
      this.apis.newBfdHeaderApi.getLoginStatus().then(res => {
        this.loginInfo = res.data;
        cache.session.set("loginInfo", res.data);
      });
    },
    onLogout() {
      let cookies = cookieKeys();
      let { hostname } = window.location;
      cookies.forEach((item) =>
        removeCookie(item, "/", `${hostname.substr(hostname.indexOf("."))}`)
      );
      cookies = cookieKeys();
      cookies.forEach((item) => removeCookie(item, "/", `.${hostname}`));
      cookies.forEach((item) => removeCookie(item, "/", hostname));
      cookies.forEach((item) => {
        document.cookie =
            item + "=;expires=" + new Date(0).toUTCString() + "; path=/";
      });
      if (unionFlag() === "chailesemanager") {
        // if(unionFlag() === 'bfd'){
        // this.apis.headerApi.getLoginOut().then((res) => {
        //   window.location.href = this.loginInfo.logoutUrl;
        // });
        this.apis.newBfdHeaderApi.getLoginOut().then((res) => {
          window.location.href = this.loginInfo.logoutUrl;
        });
      }
      window.location.href = this.loginInfo.logoutUrl;
    },
  },
};
</script>

<style lang="less" scoped>
.icon_people {
  // display: inline-block;
  // vertical-align: middle;
  // position: relative;
  // top: -2px;
  background: url("../imgs/icon_people_white_new.png") no-repeat left center;
  background-size: 16px auto;
  width: 16px;
  height: 16px;
  // background-size: cover;
  margin-right: 4px;
}
</style>
